<organization-top-navbar></organization-top-navbar>
<div>
    <div class="block; relative isolate px-6 pt-10 lg:px-8">
        <div class="mx-auto max-w-5xl px-4 py-6">
            <div class="flex justify-center">
            </div>
            <div>
                <div class="
                text-[#1B3777]
                text-center
                text-xl
                md:text-3xl
                font-bold
                md:block
                w-97  leading-normal tracking-wide">
                    {{"PARKIFLY.HOME.SKAVSTA.HERO_TITLE_1" | transloco}}
                    <br />
                </div>
                <div class="
                    text-[#1B3777]
                    text-center
                    text-3xl 
                    DisplayHeading self-stretch  md:text-6xl font-bold">
                    <div>{{"PARKING_PERMIT.DESCRIPTION" | transloco}}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Start parking details-->
    <section class="w-[95%] xl:w-[1200px] m-auto flex flex-col gap-6">
        <app-simple-search-select [selectedDepartureDate]="parkingStartTime" [selectedArrivalDate]="parkingEndTime"
            [showToggle]="false" class="flex flex-col gap-3"></app-simple-search-select>

        <div class="flex justify-end">
            <button [disabled]="!isContinueButtonEnabled"
                [ngClass]="{'bg-[#FFC700] hover:bg-[#FFD833]' : isContinueButtonEnabled, 'bg-[#FFE871] text-[#4B4A4A]': !isContinueButtonEnabled}"
                class="padding px-3 rounded-2xl w-full mb-4" (click)="goToBookingForm()">
                <div class="flex gap-2 justify-center">
                    {{"PARKIFLY.HOME.CONTINUE" | transloco}}
                    <svg [ngClass]="{'' : isContinueButtonEnabled, 'fill-[#4B4A4A]': !isContinueButtonEnabled}"
                        _ngcontent-ng-c2293421782="" class="mt-[3px]" width="21" height="20" viewBox="0 0 21 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <g _ngcontent-ng-c2293421782="" id="arrow-narrow-right">
                            <path _ngcontent-ng-c2293421782="" id="Vector" fill-rule="evenodd" clip-rule="evenodd"
                                d="M12.793 5.29303C12.9805 5.10556 13.2348 5.00024 13.5 5.00024C13.7652 5.00024 14.0195 5.10556 14.207 5.29303L18.207 9.29303C18.3945 9.48056 18.4998 9.73487 18.4998 10C18.4998 10.2652 18.3945 10.5195 18.207 10.707L14.207 14.707C14.0184 14.8892 13.7658 14.99 13.5036 14.9877C13.2414 14.9854 12.9906 14.8803 12.8052 14.6948C12.6198 14.5094 12.5146 14.2586 12.5123 13.9964C12.51 13.7342 12.6108 13.4816 12.793 13.293L15.086 11H3.5C3.23478 11 2.98043 10.8947 2.79289 10.7071C2.60536 10.5196 2.5 10.2652 2.5 10C2.5 9.73481 2.60536 9.48046 2.79289 9.29292C2.98043 9.10539 3.23478 9.00003 3.5 9.00003H15.086L12.793 6.70703C12.6055 6.5195 12.5002 6.26519 12.5002 6.00003C12.5002 5.73487 12.6055 5.48056 12.793 5.29303Z">
                            </path>
                        </g>
                    </svg>
                </div>
            </button>
        </div>
    </section>
</div>